
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { AuthProvider } from '@/providers/AuthProvider';
import PreloadResources from './components/PreloadResources';
import { initVersionControl } from './utils/version/versionControl';

// Initialize version control first, but don't block rendering
// This prevents potential infinite loops while still checking for updates
const initApp = () => {
  // Critical resources to preload
  const criticalResources = [
    "https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//bible%20tools%20AI.png",
    "https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//ai%20navigator.png",
    "https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//ai%20deep%20diveee.png",
    "https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//ai%20words.png"
  ];

  // Render the app
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AuthProvider>
        <PreloadResources resources={criticalResources} />
        <App />
      </AuthProvider>
    </React.StrictMode>
  );

  // Initialize version control after render to prevent blocking
  setTimeout(() => {
    initVersionControl().catch(err => {
      console.error("Version control initialization error:", err);
    });
  }, 1000);
};

// Start the application
initApp();
